<template>
  <div class="container">
    <loading :isLoading="true" :message="'ログイン処理中...'"></loading>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { AuthService } from '@/service/AuthService'
import { UtilService } from '@/service/UtilService'
import { useAuthStore } from '@/store/auth';
import { RouterConst } from '@/const/Router';

export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()
    const srvAuth = new AuthService()
    const authStore = useAuthStore()
    // ユーザー情報を取得する。取得出来たら施設一覧に遷移
    onMounted(async () => {
      await srvAuth.sanctum()
      await authStore.setUser()

      if (authStore.isAuth) {
        if (route.query.redirect) {
          router.push({ path: route.query.redirect as string })
        } else {
          router.push({ name: RouterConst.HOME })
        }
      } else {
        await UtilService.showAuthErrorDialog()
      }
    })

    return {

    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/pages/app-login.scss';
</style>